import styled from 'styled-components';

export const HStack = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.spacing}px;
`;

export const VStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.spacing}px;
`;
